// extracted by mini-css-extract-plugin
module.exports = {"sizechart":"sizeChart_sizechart__9LJoH"};